import React from 'react';
import OffersSection from '../components/OffersSection';

const Pricing: React.FC = () => {
  return (
    <div className="min-h-screen">
      <OffersSection />
    </div>
  );
};

export default Pricing;
